import React from "react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-secondary/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 sm:py-12 grid gap-8 sm:grid-cols-2 md:grid-cols-3">
        <div>
          <div className="font-display text-lg font-bold text-primary">Indian RE Trade</div>
          <p className="mt-2 text-sm text-muted-foreground max-w-xs">
            India's marketplace for renewable energy — projects, land, connectivity and short-term power, all in one place.
          </p>
        </div>
        <div className="text-sm">
          <div className="label-caps mb-3">Categories</div>
          <ul className="space-y-1 text-muted-foreground">
            <li>Solar · Wind · Hybrid · Hydro</li>
            <li>Land for RE parks</li>
            <li>CTU / STU connectivity</li>
            <li>Short-term RE power</li>
          </ul>
        </div>
        <div className="text-sm">
          <div className="label-caps mb-3">Trust</div>
          <p className="text-muted-foreground">
            Every listing is reviewed and approved by our admin team before it goes live.
          </p>
        </div>
      </div>
      <div className="border-t border-border/60 py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Indian RE Trade · Powering India's clean energy transition
      </div>
    </footer>
  );
}
